//=> Import React
import React from "react";

//=> Import plugins
import { Link } from "gatsby";
//=> Import Styles
import {
  footer,
  footerContent,
  madeBy,
  divider,
  footerContainer,
  dividerTransparent,
  separationOne
} from "./styles.module.scss";

const Footer = () => {
  return (
    <div className={footer}>
      <div className={footerContainer}>
        <div className={footerContent}>
          <div>
            <h5>Contact</h5>
            <p>76 Rue de Verdun 11000 Carcassonne</p>
            <p>06 ** ** ** **</p>
            <p>Horaire du magasin</p>
          </div>
          <div>
            <h5>Plan du site</h5>
            <Link to="/" title="Accueil">Accueil</Link>
            <Link to="/boutique" title="Boutique">Boutique</Link>
            <Link to="/atelier" title="Atelier">Atelier</Link>
            <Link to="/info" title="Information et contact">Information et contact</Link>
            <Link to="#" title="Mention légale">Mention légales</Link>
            <Link to="#" title="Condition générale de vente">Condition général de vente</Link>
          </div>
          <div>
            <h5>Suivez nous sur</h5>
            <a href="https://www.facebook.com/cindy.penezderoin" title="Suivez nous sur facebook">Facebook</a>
            <a href="https://www.instagram.com/berthe.aux.paquerettes/?hl=fr" title="Suivez nous sur Instagram">
              Instagram
            </a>
          </div>
        </div>
        <div className={`${divider} ${dividerTransparent}`} />
        <div className={madeBy}>
          <p>🛠 Site développé par <a href="https://github.com/Geoffrey-Maillot">Maillot Geoffrey</a> 🛠 </p>
          <p>Bertheauxpâquerettes.com 2022 - All right reserved</p>
        </div>
      </div>

    </div>
  );
};

export default Footer;
